// import Vue from 'vue'
// import WXShare from '../wx/weixin'
import wx from 'weixin-js-sdk'

// import wx from "./jweixin-1.4.0";
import Axios from 'axios'

// Vue.use(wx)

// wx.prototype.wxShare = wxShare

export default {
  /**
   * [wxRegister 微信Api初始化]
   * @param {Function} callback [ready回调函数]
   */
  wxRegister (title, desc, imgUrl) {
    // callback
    var locUrl = encodeURIComponent(window.location.href)
    var shareUrl = window.location.href
    // console.log(window.location.href.split('#')[0])
    console.log(shareUrl)

    Axios({
      method: 'get',
      // url:'http://192.168.110.245:8070/game/getSignature?url='+locUrl
      // url:'http://192.168.110.234:8080/game/getSignature?url='+locUrl
      // url: 'http://www.zxzx119.com/account/game/getSignature?url=' + locUrl,
      url: '/account' + '/game/getSignature?url=' + locUrl,
      headers: {
        orgin: 'H5'
      }
    }).then(function (response) {
      console.log('=====')
      console.log(response)
      var wxValue = response.data.data
      //
      // alert(response.data.message)
      wx.checkJsApi({
        jsApiList: [
          'chooseImage',
          'updateAppMessageShareData',
          'updateTimelineShareData'
        ], // 需要检测的 JS 接口列表，所有 JS 接口列表见附录2,
        success: function (res) {
          // 以键值对的形式返回，可用的 api 值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        }
      })

      // 微信分享配置
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wxValue['appId'], // 必填，公众号的唯一标识
        timestamp: wxValue['timestamp'], // 必填，生成签名的时间戳
        nonceStr: wxValue['noncestr'], // 必填，生成签名的随机串
        signature: wxValue['signature'], // 必填，签名
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData'
          // "onMenuShareWeibo",
          // "onMenuShareQZone"
        ] // 必填，需要使用的JS接口列表
      })

      wx.ready(function () {
        wx.updateAppMessageShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // '../assets/favicon.ico', // 分享图标
          success: function () {},
          cancel: function () {},
          fail: function () {}
        })

        wx.updateTimelineShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: shareUrl, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success () {
            // 用户成功分享后执行的回调函数
            console.log('000000')
          },
          cancel () {
            // 用户取消分享后执行的回调函数
            console.log('1111111')
          },
          fail: function () {
            console.log('2222222')
          }
        })
      })
    })
  },
  wxShareHomePage (title, desc, imgUrl) {
    // callback
    var locUrl = encodeURIComponent(window.location.href)
    var shareUrl = 'https://m.zxzx119.com/homePage/goodslist?initTab=0'
    console.log(shareUrl)
    Axios({
      method: 'get',
      // url:'http://192.168.110.245:8070/game/getSignature?url='+locUrl
      // url:'http://192.168.110.234:8080/game/getSignature?url='+locUrl
      // url: 'http://www.zxzx119.com/account/game/getSignature?url=' + locUrl,
      url: '/account' + '/game/getSignature?url=' + locUrl,
      headers: {
        orgin: 'H5'
      }
    }).then(function (response) {
      console.log(response)
      var wxValue = response.data.data
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wxValue['appId'], // 必填，公众号的唯一标识
        timestamp: wxValue['timestamp'], // 必填，生成签名的时间戳
        nonceStr: wxValue['noncestr'], // 必填，生成签名的随机串
        signature: wxValue['signature'], // 必填，签名
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareWeibo',
          'onMenuShareQZone'
        ] // 必填，需要使用的JS接口列表
      })

      wx.ready(function () {
        wx.updateAppMessageShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // '../assets/favicon.ico', // 分享图标
          success: function () {},
          cancel: function () {},
          fail: function () {}
        })

        wx.updateTimelineShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: shareUrl, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success () {
            // 用户成功分享后执行的回调函数
            console.log('000000')
          },
          cancel () {
            // 用户取消分享后执行的回调函数
            console.log('1111111')
          },
          fail: function () {
            console.log('2222222')
          }
        })
      })
    })
  },
  wxShareMall (title, desc, imgUrl, shareUrl) {
    // callback
    var locUrl = encodeURIComponent(window.location.href)
    Axios({
      method: 'get',
      // url: 'http://www.zxzx119.com/account/game/getSignature?url=' + locUrl,
      url: '/account/actUserRelation/getSignature?url=' + locUrl,
      headers: {
        orgin: 'H5'
      }
    }).then(function (response) {
      console.log(response)
      var wxValue = response.data.data
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wxValue['appId'], // 必填，公众号的唯一标识
        timestamp: wxValue['timestamp'], // 必填，生成签名的时间戳
        nonceStr: wxValue['noncestr'], // 必填，生成签名的随机串
        signature: wxValue['signature'], // 必填，签名
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData'
          // 'onMenuShareWeibo',
          // 'onMenuShareQZone'
        ] // 必填，需要使用的JS接口列表
      })
      wx.error(function (res) {
        console.log(res)
      })
      wx.ready(function () {
        wx.updateAppMessageShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // '../assets/favicon.ico', // 分享图标
          success: function () {},
          cancel: function () {},
          fail: function () {}
        })

        wx.updateTimelineShareData({
          title: title, // 分享标题
          // desc: desc, // 分享描述
          link: shareUrl, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success () {
            // 用户成功分享后执行的回调函数
            console.log('000000')
          },
          cancel () {
            // 用户取消分享后执行的回调函数
            console.log('1111111')
          },
          fail: function () {
            console.log('2222222')
          }
        })
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/wx/weixin.js